import {create} from 'zustand';

const appStore = create((set) => ({
    fromNativeApp: false,
    isLoading: false,
    activeTab: 'all',
    activeTabConfirm: 'pickup',
    addressChoice: {},
    animate: {},
    sellerIdConfirm: '',
    setFromNativeApp: (fromNativeApp) => set({fromNativeApp}),
    setLoading: (isLoading) => set({isLoading}),
    setAnimate: (animate) => set({animate}),
    setActiveTab: (activeTab) => set({activeTab}),
    setActiveTabConfirm: (activeTabConfirm) => set({activeTabConfirm}),
    setAddressChoice: (addressChoice) => set({addressChoice}),
    setSellerIdConfirm: (sellerIdConfirm) => set({sellerIdConfirm}),
}));

export default appStore;
